module.exports = __webpack_public_path__ + "static/media/miguel-perales.eb485e10.jpg";